export default {"src":"/_next/static/media/tomatoes.e488ca73.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};